export default __webpack_public_path__ + "v3.401/facebook-logo.png";